(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/pages/bankid/components/bankid-ssn.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/pages/bankid/components/bankid-ssn.js');

'use strict';

const {
  ReactButton: Button
} = svs.ui;
const Bank = svs.ui.ReactBank;
const {
  Form,
  Checkbox
} = svs.ui.reactForm;
const SSNInput = svs.ui.reactFormInputs.SSNInput;
const {
  useHistory
} = ReactRouterDOM;
const {
  bankIdSsnChangeAction,
  bankIdLoginMethodChangeAction
} = svs.playerLogin.store.playerloginreactactions;
const {
  route,
  authMethod
} = svs.playerLogin.constants;

const BankIdSsn = _ref => {
  let {
    isLogin = true
  } = _ref;
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const [ssn, setSsn] = React.useState(svs.components.Storage.browser.get('ssn', 'customer_login') || '');
  const [saveSsn, setSaveSsn] = React.useState(true);

  const onCancelClick = () => {
    if (isLogin) {
      history.push(route.LOGIN_BANKID_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_ROUTE);
    }
  };
  const onQrcodeClick = () => {
    dispatch(bankIdLoginMethodChangeAction(authMethod.QR));
    if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_QR_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_QR_ROUTE);
    }
  };
  const saveSsnToBrowser = () => {
    if (saveSsn) {
      svs.components.Storage.browser.set('ssn', 'customer_login', ssn, svs.components.Storage.constants.EXPIRES_1YEAR);
    } else {
      svs.components.Storage.browser.remove('ssn', 'customer_login');
    }
  };
  const handleSubmit = async (e, formData, isValid) => {
    e.preventDefault();
    e.stopPropagation();
    const strippedSsn = ssn.replace('-', '');
    if (!isValid) {
      return;
    }
    dispatch(bankIdSsnChangeAction(strippedSsn));
    saveSsnToBrowser();
    if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_SSNAPP_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_SSNAPP_ROUTE);
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-xs-top-2 padding-sm-top-4"
  }, React.createElement("div", {
    className: "margin-xs-top-2 margin-sm-top-4 padding-xs-bottom-2"
  }, React.createElement(Form, {
    method: "post",
    onSubmit: (e, formData, isValid) => {
      handleSubmit(e, formData, isValid);
    }
  }, React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(SSNInput, {
    id: "ssn",
    inverted: true,
    name: "ssn",
    onChange: e => setSsn(e.target.value),
    value: ssn
  })), React.createElement("div", {
    className: "margin-xs-top-1 align-left"
  }, React.createElement(Checkbox, {
    branding: "inverted",
    checked: saveSsn,
    className: "login-react-checkbox",
    id: "saveSsn"
    ,
    name: "saveSsn",
    onChange: e => setSaveSsn(e.target.checked)
  }, "Kom ih\xE5g personnummer")), React.createElement("div", {
    className: "margin-xs-top-2"
  }, React.createElement(Button, {
    block: true,
    iconPosition: "left",
    size: 300,
    type: "submit"
  }, React.createElement(Bank, {
    name: "bankid-promo",
    size: 24
  }), "Logga in"))))), React.createElement("div", {
    className: "margin-xs-top-3"
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: onQrcodeClick,
    size: 300,
    transparent: true
  }, "Logga in med QR-kod")), React.createElement("div", {
    className: "margin-xs-top-2"
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLogin.bankid.components.BankIdSsn = BankIdSsn;

 })(window);